export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return;
  }
  if (to.meta.auth === false) {
    return;
  }
  const { isAuthenticated } = useEntraAuth();
  if (!isAuthenticated.value) {
    return navigateTo('/auth/login');
  }
});
